var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHelp32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22a1 1 0 100-2 1 1 0 000 2zm3.25-8.985c0-1.525-1.439-2.765-3.25-2.765-1.812 0-3.255 1.24-3.255 2.765a.75.75 0 001.5 0l.007-.107c.075-.602.776-1.158 1.748-1.158 1.028 0 1.75.622 1.75 1.265 0 .487-.176.679-.834 1.005l-.385.193c-.878.459-1.282.902-1.281 1.788V18l.007.101a.75.75 0 001.493-.1v-2.002c0-.182.092-.27.625-.532l.4-.201c.985-.528 1.475-1.13 1.475-2.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 16C4.25 9.51 9.51 4.25 16 4.25S27.75 9.51 27.75 16 22.49 27.75 16 27.75 4.25 22.49 4.25 16zm22 0c0-5.66-4.59-10.25-10.25-10.25S5.75 10.34 5.75 16 10.34 26.25 16 26.25 26.25 21.66 26.25 16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp32);
export default __webpack_public_path__ + "static/media/icon-help-32.c181a4cb.svg";
export { ForwardRef as ReactComponent };